import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import dayjs from 'dayjs';

import CardLarge from '../../../common/CardLarge';
import { getClassroomImageUrl } from '../../../../services/assets/assetsService';

class ClassroomArchiveCard extends React.Component {
  static propTypes = {
    id: PropTypes.any.isRequired,
    classCode: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    archiveDate: PropTypes.object.isRequired,
    optionItems: PropTypes.any,
    picture: PropTypes.string,
    asset: PropTypes.string
  };

  render() {
    const { id, name, archiveDate, optionItems, picture, asset } = this.props;
    const textBottom = `${I18n.t('home.archivedOn')} ${dayjs(archiveDate).format('DD/MM/YYYY')}`;
    const entryPoint = '/classroom';
    let classroomImgUrl = getClassroomImageUrl(id, picture || asset);

    return (
      <div>
        <CardLarge
          textTop={name}
          textBottom={textBottom}
          entryPoint={entryPoint}
          id={id}
          img={classroomImgUrl}
          type="archived"
          optionItems={optionItems}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    classroomsImages: state.theme.images.classrooms
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomArchiveCard);
